import { render } from "./SettingsButton.vue?vue&type=template&id=63542cc8&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"

import "./SettingsButton.vue?vue&type=style&index=0&id=63542cc8&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63542cc8"]])

export default __exports__